import { Paper } from "@mui/material";
import Stack from "@mui/material/Stack";
import Tabs from "@mui/material/Tabs";
import { useLocation } from "@reach/router";
import { cs, Icons, useIsDesktop } from "@repo/ui";
import { type FC, useEffect } from "react";
import { LinkTab } from "../Link/LinkTab";
import { useNavigationTabs } from "./context";

export const bottomNavLinks = [
	{
		label: cs.bottomNavigationBar.dashboard,
		to: "smlouvy",
	},
	{
		label: cs.bottomNavigationBar.documents,
		to: "dokumenty",
	},
	{
		label: cs.bottomNavigationBar.profile,
		to: "profil",
	},
	{
		label: cs.bottomNavigationBar.contacts,
		to: "kontakty",
	},
];


const BottomNavigation: FC<{ variant?: "desktop"; }> = ({ variant }) => {
	const { activeTabId, setActiveTabId } = useNavigationTabs();
	const { pathname } = useLocation();

	useEffect(() => {
		let currentIcon;
		bottomNavLinks.forEach((link, index) => {
			if (pathname.includes(link.to)) {
				currentIcon = index;
			}
		});

		if (typeof currentIcon === "number") setActiveTabId(currentIcon);
		else setActiveTabId(false);
	}, []);

	return (
		<Paper
			sx={{
				position: variant === "desktop" ? "static" : "fixed",
				right: 0,
				bottom: 0,
				left: 0,
				display: {
					md: variant === "desktop" ? "block" : "none",
					xs: variant === "desktop" ? "none" : "block",
				},
			}}
			elevation={variant === "desktop" ? 0 : 3}
		>
			<Tabs
				value={activeTabId}
				aria-label="Navigace"
				sx={{
					".MuiTabs-flexContainer": {
						justifyContent: "space-evenly",
						width: "100%",
					},
				}}
				TabIndicatorProps={{
					style: {
						bottom: variant === "desktop" ? 0 : "unset",
						top: variant === "desktop" ? "unset" : 0,
					},
				}}
			>
				<LinkTab
					to={`/${bottomNavLinks[0].to}/`}
					label={bottomNavLinks[0].label}
					icon={
						<Stack>
							<Icons.House sx={{ width: "2.1rem", height: "2.1rem" }} />
						</Stack>
					}
					variant={variant}
				/>
				<LinkTab
					to={`/${bottomNavLinks[1].to}/`}
					label={bottomNavLinks[1].label}
					icon={
						<Stack>
							<Icons.Documents sx={{ width: "1.8rem", height: "2.1rem" }} />
						</Stack>
					}
					variant={variant}
				/>
				<LinkTab
					to={`/${bottomNavLinks[2].to}${useIsDesktop() ? "/moje-udaje" : ""}/`}
					label={bottomNavLinks[2].label}
					icon={
						<Stack>
							<Icons.MyAccount sx={{ width: "2.4rem", height: "2.4rem" }} />
						</Stack>
					}
					variant={variant}
				/>
				<LinkTab
					to={`/${bottomNavLinks[3].to}/`}
					label={bottomNavLinks[3].label}
					icon={
						<Stack>
							<Icons.Contacts sx={{ width: "2.4rem", height: "1.8rem" }} />
						</Stack>
					}
					variant={variant}
				/>
			</Tabs>
		</Paper>
	);
}

export default BottomNavigation;


export const BottomNavigationDesktopComponent: FC = () => {
	return <BottomNavigation variant="desktop" />
}